export default __webpack_public_path__ + "static/media/content_copy_black_24dp.835b9534.svg";